export const DAY_WIDTH_PX = 31;
/** Left inset within each day column — shared by day header numbers and item badges. */
export const DAY_CELL_HORIZONTAL_PADDING_PX = 10;

export const WEEKDAY_COLOR = '#909090';
export const WEEKEND_COLOR = '#B1B1B1';

export const MONTH_HEADER_HEIGHT_PX = 74;
export const CONTROLS_MIN_WIDTH_PX = 99;
export const MUST_WINS_CONTROLS_MIN_WIDTH_PX = 299;
export const MUST_WINS_AUDIENCE_COLUMN_WIDTH_PX = 100;
export const MUST_WINS_STRATEGY_COLUMN_WIDTH_PX = 200;

export const MONTHLY_TREE_CHEVRON_WIDTH_PX = 8;
export const MONTHLY_TREE_CURVE_RADIUS_PX = 5;
export const MONTHLY_TREE_HORIZONTAL_BRANCH_PX = 11;
export const MONTHLY_TREE_BRANCH_TO_CARD_GAP_PX = 10;
/** Fallback indent before connector layout is measured. */
export const MONTHLY_TREE_CHILD_INDENT_PX =
  MONTHLY_TREE_CHEVRON_WIDTH_PX / 2 +
  MONTHLY_TREE_CURVE_RADIUS_PX +
  MONTHLY_TREE_HORIZONTAL_BRANCH_PX +
  MONTHLY_TREE_BRANCH_TO_CARD_GAP_PX;
